import React, { FC, lazy, Suspense } from "react";
import { BaseProp } from "entities/BaseProp";
import HeadingText2 from "components/HeadingText/HeadingText2";
import HelmetComponent from "components/HelmetComponent/HelmetComponent";

const CommanCardPage = lazy(() => import("./CommanCardPage"));

export interface BannersDetailPageProps extends BaseProp {}

const BannersDetailPage: FC<BannersDetailPageProps> = ({ className = "" }) => {
  const svgSizeClass = `h-[70px] w-[70px] sm:h-[100px] sm:w-[100px]`;
  return (
    <div className={`nc-AboutUs ${className}`} data-nc-id="AboutUs">
      {/* Title & meta data */}
      <HelmetComponent
        title="Clearance & Limited-Time Offers | CSC LED"
        metaDescription="Shop CSC LED’s clearance and limited-stock deals on high-performance commercial lighting. Save on discontinued and overstock products—only while supplies last!"
        metaKeywords="Shop CSC LED, LED lighting company, Sustainable lighting solutions, Energy-efficient lighting provider, CSC LED mission and values, High-quality LED products, LED lighting expertise, Lighting innovation"
      />
      <div className="container text-[15px] text-justify pt-12 pb-16 lg:pb-28">
        <HeadingText2 className="text-center sm:text-left">What do these banners mean?</HeadingText2>
        <Suspense fallback={<div>Loading...</div>}>
          <CommanCardPage />
        </Suspense>
      </div>
    </div>
  );
};

export default BannersDetailPage;
